import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="best-quality-selector"
export default class extends Controller {
  static values = { ids: Array }
  
  selectBest(event) {
    event.preventDefault()
    
    // Clear all checkboxes first
    const form = this.element.closest('form')
    if (!form) return
    
    form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false
    })
    
    // Check only the best quality ones
    this.idsValue.forEach(id => {
      const checkbox = form.querySelector(`input[type="checkbox"][name$="[${id}]"]`)
      if (checkbox) {
        checkbox.checked = true
      }
    })
  }
}